export default "__VITE_ASSET__Byro4Lfr__"